<div id="smart-send-confirm-map-container" class="md:tw-flex-row tw-flex-col">
  <mgl-map
    [style]="styleUrl"
    [zoom]="[Zoom]"
    [center]="center"
    [transformRequest]="transformReq"
    [preserveDrawingBuffer]="true"
    class="map expanded md:tw-order-2 tw-order-1 md:tw-w-[calc(100% - 300px)] tw-w-full"
    [class.tw-rounded-[20px]]="rounded"
    (load)="onMapReady($event)"
    [cursorStyle]="cursorStyle"
    [style.height]="height + 'px'"
  >
    <mgl-control *ngIf="isShowToolbar">
      <div class="mapboxgl-ctrl-group">
        <button
          type="button"
          title="{{ 'common.collapseMap' | translate }}"
          aria-label="Collapse map"
          aria-disabled="false"
          *ngIf="!isExpandMap"
          (click)="emitExpandCollapseMap('expand')"
        >
          <i class="save-icon mdi mdi-arrow-collapse"></i>
        </button>

        <button
          class=""
          type="button"
          title="{{ 'common.expandMap' | translate }}"
          aria-label="Expand map"
          aria-disabled="false"
          *ngIf="isExpandMap"
          (click)="emitExpandCollapseMap('collapse')"
        >
          <i class="save-icon mdi mdi-arrow-expand"></i>
        </button>
      </div>
    </mgl-control>

    <mgl-control *ngIf="isShowToolbar" mglNavigation></mgl-control>

    <mgl-control *ngIf="isShowToolbar">
      <div class="mapboxgl-ctrl-group">
        <button
          class=""
          type="button"
          title="{{ 'common.help' | translate }}"
          aria-label="Help"
          aria-disabled="false"
          (click)="onHelpButtonClick($event)"
        >
          <i class="help-icon mdi mdi-help-box"></i>
        </button>
        <button
          class=""
          type="button"
          [title]="'common.addToPublicPlace' | translate"
          aria-label="Add To Public Place"
          aria-disabled="false"
          (click)="onAddToPublicPlaceButtonClick()"
          *ngIf="ShowAddToPublicPlace"
        >
          <i class="save-icon mdi mdi-file-document-plus"></i>
        </button>
      </div>
    </mgl-control>

    <mgl-geojson-source
      id="polygon-source"
      [data]="DisplayPolygon"
    ></mgl-geojson-source>

    <mgl-layer
      id="display-polygon-area"
      type="fill"
      source="polygon-source"
      [paint]="{
        'fill-color': DisplayPolygonFillColor,
        'fill-opacity': DisplayPolygonFillOpacity
      }"
      (click)="onLayerClick($event)"
      (layerMouseMove)="activateHoverOn($event)"
      (layerTouchStart)="onLayerClick($event)"
      (layerMouseLeave)="disableHover()"
    ></mgl-layer>
    <!-- selected layer-->
    <mgl-layer
      id="selected-polygon-area"
      type="fill"
      source="polygon-source"
      [paint]="{
        'fill-color': SelectedPolygonFillColor,
        'fill-opacity': SelectedPolygonOpacity
      }"
      [filter]="selectedFilter"
    ></mgl-layer>
  </mgl-map>
</div>

<!--#region table-->
<div
  *ngIf="isShowRecipients && (isDetailPage || showDetail)"
  class="w-full tw-flex-center"
>
  <div
    class="md:tw-w-full tw-mb-2 formulas-table !tw-p-0 tw-mt-4 tw-relative table-responsive"
  >
    <table
      class="table table-active tw-text-center table-head-custom table-vertical-center overflow-hidden tw-border tw-border-gray-200"
    >
      <thead class="tw-border-b tw-border-gray-200">
        <tr class="fw-bold fs-6 tw-text-gray-800">
          <th>
            {{ "common.operator" | translate }}
          </th>
          <th>
            {{ "common.priceFa" | translate }}
          </th>
          <th>
            {{ "common.priceEn" | translate }}
          </th>
          <th *ngIf="!isDetailPage">
            {{ "common.totalPriceFa" | translate }}
          </th>
          <th *ngIf="!isDetailPage">
            {{ "common.totalPriceEn" | translate }}
          </th>
          <th *ngIf="!isDetailPage">
            {{ "pages.sendSmsFromMap.fields.startFrom" | translate }}
          </th>
          <th *ngIf="!isDetailPage">
            {{ "pages.sendSmsFromMap.fields.count" | translate }}
          </th>
          <th>
            {{ "pages.sendSmsFromMap.fields.total" | translate }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          class="tw-text-center table-tr"
          *ngFor="let item of model; let index = index"
          [ngClass]="{
            'tr-expired': convertJsonToString(item?.polygon) == selectedPolygon
          }"
          (click)="showPolygonOnMap(convertJsonToString(item?.polygon))"
        >
          <td class="tw-flex-center">
            <div
              class="tw-justify-center"
              [mobileOperatorImg]="{
                mobileOperator: item?.operator,
                mobileOperatorEnumValue:
                  item?.operator | enumToText : SmsAggregatorsEnumValues
              }"
            ></div>
          </td>
          <td>{{ item.persianPrice | numberSeparator }}</td>
          <td>{{ item.englishPrice | numberSeparator }}</td>
          <td *ngIf="!isDetailPage">
            {{
              item.persianPrice * item.sendCount * SmsParts | numberSeparator
            }}
          </td>
          <td *ngIf="!isDetailPage">
            {{
              item.englishPrice * item.sendCount * SmsParts | numberSeparator
            }}
          </td>
          <td *ngIf="!isDetailPage" class="tw-px-0 tw-py-2">
            <!-- fromIndex -->
            <input
              [onlyNumbers]="true"
              type="tel"
              min="1"
              placeholder="0"
              class="index-input tw-text-center tw-w-[65px] tw-mx-1 dir-ltr dark:tw-bg-dark-200"
              [ngModel]="
                item?.startFrom <= 0 ? 1 : (item?.startFrom | numberSeparator)
              "
              numberSeparator
              [attr.data-from-index-input-id]="item.id"
              (input)="changeStartFrom(item, item.total, $event)"
              [cursorPointer]="true"
              [disabled]="item.total == 0"
            />
          </td>

          <!-- count -->
          <td *ngIf="!isDetailPage" class="tw-px-0">
            <input
              [onlyNumbers]="true"
              type="tel"
              min="1"
              placeholder="0"
              [ngModel]="item?.sendCount | numberSeparator"
              class="index-input tw-text-center tw-w-[65px] tw-mx-1 dark:tw-bg-dark-200"
              numberSeparator
              [attr.data-count-input-id]="item.id"
              (input)="changeCount(item, item.total, $event)"
              [cursorPointer]="true"
              [disabled]="item.total == 0"
            />
          </td>

          <td>{{ item.total | numberSeparator }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- submit btn -->
<div
  *ngIf="isShowRecipients && !isDetailPage && showDetail"
  class="text-end tw-mt-8"
>
  <button
    type="button"
    mat-ripple
    [disabled]="isWrongIndex"
    class="btn tw-py-2 tw-mb-1 tw-mt-4 sm:tw-w-1/3 tw-w-full button-shadow btn-hover-rise text-white"
    [themeColor]="'btn-gradient'"
    mat-button
    (click)="onBtnNextStep()"
  >
    {{ NextStepText | translate }}
    <i class="fas fa-paper-plane tw-text-2xl"></i>
  </button>
</div>
